module.exports = __webpack_public_path__ + "static/media/cause-education.59a8d90b.jpg";